
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.151 22.674a5.867 5.867 0 00-8.818-2.456m20.516 2.456a5.866 5.866 0 018.818-2.456m-8.52 2.802a7.907 7.907 0 00-12.293 0m-1.676-8.31a3.422 3.422 0 11-6.845 0 3.422 3.422 0 016.845 0zm22.488 0a3.422 3.422 0 11-6.844 0 3.422 3.422 0 016.844 0zM20.4 13.734a4.4 4.4 0 11-8.8 0 4.4 4.4 0 018.8 0z","stroke":"#121131","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    